import {
  Flex,
  FlexProps,
  Icon,
  SecondaryButton,
  Typo,
  xsBumps,
  xxsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { canCancel } from '../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useProduct } from '../../productContext'
import { PolicyPath } from '../PolicyPath'
import { usePolicy } from '../PolicyProvider'
import { PolicySidebarPricing } from '../pricing'

const tKey = TKey('components.policy-sidebar')

export const PolicySidebar: FunctionComponent<FlexProps> = (props) => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const { product } = useProduct()
  const { policy } = usePolicy()

  const onCancelCallback = useCallback(() => navigate(PolicyPath.CANCEL), [navigate])

  const callToAction = canCancel(policy, product.cancellation) && (
    <Flex flexDirection='column' width={1} px={5} pt={5}>
      <SecondaryButton
        width={1}
        onClick={onCancelCallback}
        data-testid='button-cancel-policy'
      >
        {t(tKey('actions.cancel'))}
      </SecondaryButton>
    </Flex>
  )

  const benefits = t(tKey('benefits'), {
    returnObjects: true,
    defaultValue: [],
  }) as string[]

  const benefitsSection = benefits.map((benefit, index) => (
    <Flex justifyContent='flex-start' width={1} my={xxsBumps} key={index}>
      <Icon icon='tick' size='small' mr={xsBumps} />
      <Typo typoSize='sm'>{benefit}</Typo>
    </Flex>
  ))

  return (
    <Flex width={1} flexDirection='column' variant='raised' {...props}>
      <PolicySidebarPricing
        policy={policy}
        product={product}
        borderBottomWidth={1}
        width={1}
      />
      {callToAction}
      {Boolean(benefitsSection.length) && (
        <Flex flexDirection='column' width={1} p={5}>
          {benefitsSection}
        </Flex>
      )}
    </Flex>
  )
}
